module.exports = __webpack_public_path__ + "img/youtube-icon.1af1d5cc.svg";